import Container from '~/components/Container';
import Button from '~/components/Button';
import { useTitle } from '~/lib/useTitle';
import s from './NotFound.module.scss';

export default function NotFound() {
  useTitle('Not found — MetaHub');

  return (
    <section className={s.wrap}>
      <Container className={s.inner}>
        <div className={s.code}>404</div>
        <h1>This page wandered off.</h1>
        <p>The page you’re looking for doesn’t exist or has moved.</p>
        <Button to="/" size="lg">
          Back home
        </Button>
      </Container>
    </section>
  );
}
